<template>
    <div v-show="orderId" class="row text-center" :class="{'mt-5': inProgress}">
        <div class="col-12">
            <div class="card">
                <div class="card-body">
                    <p class="mb-0"><small v-show="orderId !== null">{{ $t('Ordre ID') }}: {{ orderId }}</small></p>
                    <p class="mb-0"><small v-show="amount !== 0">{{ $t('Beløp') }}: {{ displayAmount }} kr</small></p>
                    <p class="fw-bold" :class="titleClasses" v-show="title">{{ title }}</p>
                    <p>{{ description }}</p>

                    <div class="text-center" v-show="inProgress">
                        <span class="spinner-border" role="status"></span>
                    </div>

                    <div class="row justify-content-center mt-3">
                        <div class="col-sm-6 col-12 order-1 order-sm-0 mb-1" v-show="!inProgress">
                            <a href="/" class="btn btn-secondary btn-block btn-sm-inline cursor-pointer">{{ $t('Gå til {brandName}', {brandName}) }}</a>
                        </div>
                        <div class="col-sm-6 col-12 order-0 order-sm-1 mb-1 text-end" v-show="displayTryAgainButton">
                            <a :href="tryAgainLink" class="btn btn-primary btn-block btn-sm-inline">
                                {{ $t('Prøv igjen') }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue';
import { toMoney } from '../../lib/format';
import Api from '../../api/Payment';
import Store from '../../state/paymentStore';

const props = defineProps(['orderId', 'paymentHash']);

const inProgress = ref(false);
const currentAttempt = ref(1);
const maxAttempts = ref(100);
const secondsBetweenEachCheck = ref(3);
const description = ref('');
const displayTryAgainButton = ref(false);
const amount = ref(0);
const title = ref('');
const title_class = ref('');

const brandName = computed(() => window.brandingName.toUpperCase());
const displayAmount = computed(() => toMoney(amount.value));
const titleClasses = computed(() => {
    const cssClasses = {};
    cssClasses[title_class.value] = true;
    if (!inProgress.value) {
        cssClasses['text-2xl'] = true;
    }
    return cssClasses;
});
const tryAgainLink = computed(() => {
    if (props.paymentHash === null) {
        return '/betaling';
    }
    return '/p/' + props.paymentHash;
});

const checkStatus = (orderId) => {
    Api.GetTransactionStatus({
        attempt: currentAttempt.value,
        max: maxAttempts.value,
        orderId: orderId,
    }).then(res => {
        setPaymentData(res.data);
        currentAttempt.value++;

        if (inProgress.value) {
            setTimeout(() => checkStatus(orderId), secondsBetweenEachCheck.value * 1000);
        } else {
            Store.setLoading(false);
            Store.setPaymentStatusComplete();
        }
    }).catch(e => {
        console.log(e);
    });
};

const setPaymentData = (data) => {
    inProgress.value = data.inprogress;
    description.value = data.description;
    title.value = data.title;
    title_class.value = data.title_class;
    displayTryAgainButton.value = data.try_again_btn;
    if (data.amount) {
        amount.value = data.amount;
    }
};

watch(() => props.orderId, (newVal) => {
    if (newVal !== null) {
        checkStatus(newVal);
    }
});

onMounted(() => {
    if (props.orderId !== null) {
        checkStatus(props.orderId);
    }
});
</script>
